import ScrollHandler from "./ScrollHandler";

export default ScrollHandler;
